import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));

export const Home = Loadable(lazy(() => import("../pages/Home")));
export const Pilot = Loadable(lazy(() => import("../pages/Pilot")));
export const Clone = Loadable(lazy(() => import("../pages/Clone")));
export const Backfill = Loadable(lazy(() => import("../pages/Backfill")));

export const UserListPage = Loadable(
  lazy(() => import("../pages/UserListPage"))
);
export const UserProfilePage = Loadable(
  lazy(() => import("../pages/UserProfilePage"))
);
export const DataPage = Loadable(lazy(() => import("../pages/Data")));
export const FeedbackPage = Loadable(lazy(() => import("../pages/Feedback")));
export const LinksPage = Loadable(lazy(() => import("../pages/LinksPage")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
export const ControlFlagPage = Loadable(
  lazy(() => import("../pages/ControlFlagPage"))
);
export const BanditWebhooksPage = Loadable(
  lazy(() => import("../pages/BanditWebhooksPage"))
);
export const CheckIn = Loadable(lazy(() => import("../pages/CheckIn")));
export const ScalePage = Loadable(lazy(() => import("../pages/ScalePage")));